import { useState } from 'react';

interface StatsSectionProps {
  stats: { value: string; label: string }[];
}

export default function StatsSection({ stats }: StatsSectionProps) {
  const [animated, setAnimated] = useState(false);

  return (
    <section className="relative -mt-10 z-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div
          className="bg-background-50 rounded-2xl border border-background-200/70 py-8 px-6 grid grid-cols-2 md:grid-cols-4 gap-6"
          ref={(el) => {
            if (el && !animated) {
              setAnimated(true);
            }
          }}
        >
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}